import pancakePair from "../abis/pancakePair";

const host = "https://bscscan.com/address";

export default {
  title: "Pancake Pair",
  contractAddress: "0x1B96B92314C44b159149f7E0303511fB2Fc4774f",
  abi: pancakePair.abi,
  url: `${host}/0x1B96B92314C44b159149f7E0303511fB2Fc4774f`,
};
